<template>
  <div class="modal-panel">
    <div class="modal-head">
      <h3 class="modal-title">{{ titulo }} categoría</h3>
      <p class="modal-sub">Los campos con * son obligatorios</p>
    </div>

    <div class="modal-body">
      <div class="field">
        <label class="field-label">Nombre *</label>
        <v-text-field v-model="categoriaLocal.nombre" :error-messages="errores.nombre" outlined dense
          hide-details="auto" placeholder="Ej. Piernas" class="dark-input"></v-text-field>
      </div>

      <div class="field">
        <label class="field-label">Descripción</label>
        <v-textarea v-model="categoriaLocal.descripcion" outlined dense rows="2" hide-details="auto"
          placeholder="Describe brevemente la categoría" class="dark-input"></v-textarea>
      </div>

      <div class="field">
        <label class="field-label">Ícono</label>
        <v-combobox v-model="categoriaLocal.icono" :items="opcionesIconos" outlined dense hide-details="auto"
          append-icon="mdi-emoticon-outline" placeholder="Selecciona o escribe el nombre de un ícono"
          class="dark-input">
          <template v-slot:selection="data">
            <v-icon size="16" color="#C8FF4D" class="mr-2">{{ data.item }}</v-icon>
            <span>{{ data.item }}</span>
          </template>
          <template v-slot:item="data">
            <v-icon size="16" class="mr-2">{{ data.item }}</v-icon>
            <span>{{ data.item }}</span>
          </template>
        </v-combobox>

        <div class="icon-preview">
          <template v-if="categoriaLocal.icono">
            <div class="icon-preview-box">
              <v-icon size="18" color="#C8FF4D">{{ categoriaLocal.icono }}</v-icon>
            </div>
            <span class="icon-preview-text">{{ categoriaLocal.icono }}</span>
          </template>
          <span v-else class="icon-preview-placeholder">Previsualización del ícono</span>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-ghost" @click="cerrar">Cancelar</button>
      <button class="btn-primary" :disabled="!esValido" @click="guardar">Guardar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormCategoriaEjercicio",
  props: {
    categoria: {
      type: Object,
      default: () => ({})
    },
    titulo: {
      type: String,
      default: "Agregar"
    }
  },
  data() {
    return {
      categoriaLocal: { ...this.categoria },
      errores: {
        nombre: ""
      },
      opcionesIconos: [
        'mdi-dumbbell', 'mdi-run', 'mdi-run-fast', 'mdi-yoga', 'mdi-arm-flex',
        'mdi-weight-lifter', 'mdi-bike', 'mdi-swim', 'mdi-walk', 'mdi-handball',
        'mdi-karate', 'mdi-soccer', 'mdi-basketball', 'mdi-baseball', 'mdi-volleyball',
        'mdi-tennis', 'mdi-golf', 'mdi-ski', 'mdi-snowboard', 'mdi-skateboarding',
        'mdi-surfing', 'mdi-hiking', 'mdi-kayaking', 'mdi-heart', 'mdi-star', 'mdi-shape'
      ]
    };
  },
  computed: {
    esValido() {
      return this.categoriaLocal.nombre && this.categoriaLocal.nombre.trim() !== "";
    }
  },
  watch: {
    categoria: {
      handler(nuevoValor) {
        this.categoriaLocal = { ...nuevoValor };
      },
      deep: true
    },
    'categoriaLocal.nombre': function (valor) {
      this.validarNombre(valor);
    }
  },
  methods: {
    validarNombre(nombre) {
      if (!nombre || nombre.trim() === "") {
        this.errores.nombre = "El nombre es obligatorio";
      } else {
        this.errores.nombre = "";
      }
    },
    cerrar() {
      this.$emit('cerrado', false);
    },
    guardar() {
      if (this.esValido) {
        this.$emit('registrar', { ...this.categoriaLocal });
      }
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.modal-panel {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
  font-family: var(--font-body);
  color: var(--text-primary);
}

.modal-head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--card-border);
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: capitalize;
}

.modal-sub {
  font-size: 12.5px;
  color: var(--text-secondary);
  margin: 0;
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.icon-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
}

.icon-preview-box {
  width: 34px;
  height: 34px;
  border-radius: var(--radius);
  background: rgba(200, 255, 77, 0.12);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-preview-text {
  font-family: var(--font-mono, monospace);
  font-size: 12.5px;
  color: var(--text-secondary);
}

.icon-preview-placeholder {
  font-size: 12px;
  color: var(--text-tertiary);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== Overrides Vuetify (v-text-field, v-textarea, v-combobox) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input,
.dark-input >>> textarea {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder,
.dark-input >>> textarea::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

.dark-input >>> .v-messages__message {
  font-size: 11px !important;
}

/* Menú desplegable del combobox */
.modal-panel >>> .v-menu__content {
  background: var(--card) !important;
  border: 1px solid var(--card-border) !important;
  border-radius: 4px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5) !important;
}

.modal-panel >>> .v-list {
  background: transparent !important;
  padding: 4px !important;
}

.modal-panel >>> .v-list-item {
  border-radius: 4px !important;
  display: flex;
  align-items: center;
}

.modal-panel >>> .v-list-item .v-icon {
  color: var(--text-secondary) !important;
}

.modal-panel >>> .v-list-item span {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13px !important;
}

.modal-panel >>> .v-list-item:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Planes/FormCategoriaEjercicio.vue